export const SET_PENDING_CASE_IDS: string = "set_pending_case_ids";
export const SET_PENDING: string = "set_pending";
export const SET_UPLOAD_START: string = "set_upload_start";
export const SET_UPLOAD_IN_PROGRESS: string = "set_upload_in_progress";
export const SET_UPLOAD_COMPLETE: string = "set_upload_complete";
export const SET_NEW_CASE_CREATED: string = "set_new_case_created";
export const SET_CASE_DETAILS_UPDATED: string = "set_case_details_updated";
